<template>
    <div class="Frame">
        <div class="ShopperTableIndex">
            <div class="ShopperTableIndexText">
                <h1>{{ this.risorse["CarrelloTitolo"] }}</h1>
                <p v-html=" this.risorse['CarrelloTesto']"></p>
            </div>
            <div class="ShopperTableIndexAddBox">
                <div class="AddShopBox">
                    <div class="AddShopPanel">
                        <div class="Frame">
                            <div class="AddShopPanelTable">
                                <table width="100%" border="0" cellspacing="0" cellpadding="0">
                                    <tbody>
                                        <tr>
                                            <td v-html=" this.risorse['TotalProd']"></td>
                                            <td>{{this.simboloValuta}} {{this.formatNumber((this.totalArts ), 2, ',', '.')}}</td>
                                        </tr>  
                                        <tr>
                                            <td>{{this.risorse["TotalSpSped"]}}</td>
                                            <td>{{this.simboloValuta}} {{this.formatNumber((this.spSped ), 2, ',', '.')}}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ this.risorse["TotaleOrdine"] }}</td>
                                            <td>{{this.simboloValuta}} {{this.formatNumber((this.totalCart ), 2, ',', '.')}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="SeasonalOrderChoice" v-if="this.ShowSeasonlOrderForm">
                                <form class="Form">
                                    <fieldset>
                                        <legend>{{ this.risorse['seasonalOrder'] }}</legend>

                                        <div class="FormRow">
                                            <div class="FormBoxWide FormCheckBox" style="margin-bottom:10px;">
                                                <div class="Label" v-html="this.risorse['inviaComeSeas']"></div>
                                                <div class="Field"><input type="checkbox" v-model="this.ChkSeasonalOrder" id=""  /><label for="" class="checkmark"></label></div>
                                            </div>
                                        </div>
                                        <div class="FormRow SeasonalDate centerElement" :class="{ visible:this.ChkSeasonalOrder }">
                                            <div class="FormBox66 align-y ">
                                                <label>{{ this.risorse['scegliLaData'] }}</label>
                                                <input type="date" name="" v-model="this.DataSeasonal">
                                            </div>
                                            <div class="FormBox33 align-y ">
                                                <div class="Button CustomColor Small"><a @click="this.SetSeasonalDate()">{{this.risorse['applica']}}</a></div>
                                            </div>
                                            <div class="SeasonalText">{{this.risorse['seasonalDescr']}}<a href="/seasonalorder.asp">{{ this.risorse['maggioriInfo'] }}</a></div>
                                        </div>
                                    </fieldset>
                                </form>
                            </div>
                            <div v-if="!this.CheckOutAbilitato" class="Button Disabled Iconed AddShop"><a href="javascript:void(0)">{{ this.risorse["OrdinaOra"] }}</a></div>
                            <div v-else class="Button CustomColor Iconed AddShop"><a @click="this.showModal=true">{{ this.risorse["OrdinaOra"] }}</a></div>
                            <div v-if="this.CalcolaSp" class="Button SelectedItem CustomColor Iconed Calc">
                                <a href="javascript:void(0)" @click="this.calcolaSpSped">{{this.risorse["CalcSpSped"]}}</a>
                            </div>
                            <div v-else class="Button SelectedItem CustomColor Iconed Calc Disabled"><a>{{this.risorse["CalcSpSped"]}}</a></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ModalSendOrder v-model="this.showModal" />
</template>

<script>

import {priceMixin, valutaMixin, risorseMixin, dateMixin} from "@/mixin.js";
import ModalSendOrder from "@/components/modals/ModalSendOrder.vue";
import CartService from '@/services/cart.service.js';

export default {
    name: "CartSummary",
    data(){
        return {
            showModal: false,
            CalcolaSp: true,
            ChkSeasonalOrder:false,
            DataSeasonal: '',
        }
    },
    computed: {
        ShowSeasonlOrderForm: function(){
            console.log(this.$store.getters.getChkSeasonalOrders)
            return this.$store.getters.getChkSeasonalOrders;
        },
        totalArts: function(){
            return this.$store.getters.getPrezzoTotale;
        },
        spSped: function(){
            return (this.$store.getters.getSpSpedizione?.TotSpeseSpedizione ?? 0);
        },
        totalCart: function(){
            return this.$store.getters.getPrezzoTotale + (this.$store.getters.getSpSpedizione?.TotSpeseSpedizione ?? 0);
        },
        indSped: function(){
            return this.$store.getters.getShippingAddress;
        },
        CheckOutAbilitato: function(){
            let rb = this.$store.getters.getCarrello?.Righe?.filter(x => x.IsBackorder == 1);
            let r = this.$store.getters.getCarrello?.Righe?.filter(x => x.IsBackorder == 0);
            if((rb != null && rb.length > 0) && (r == null || r.length == 0)){
                this.CalcolaSp = false;
                return true;
            }else{
                this.CalcolaSp = true;
                return this.$store.getters.getCheckOutAbilitato;
            }
        }
    },
    watch:{
        indSped: function(newValues,oldValues){
            if(newValues != oldValues && newValues != null){
                this.$store.commit('setCheckOutAbilitato',false);
            }
        },
        ChkSeasonalOrder: function(newValues,oldValues){
            if(oldValues == true && newValues == false){
                this.SetSeasonalDate(true);
            }
        }
    },
    props:{
        shippindAddress: Number
    },
    mixins: [priceMixin, valutaMixin, risorseMixin, dateMixin],
    components:{
        ModalSendOrder
    },
    mounted:function(){
        this.DataSeasonal = this.$store.getters.getCarrello?.Testata?.SeasonalData;
        if(this.DataSeasonal != null && this.DataSeasonal != undefined && this.DataSeasonal != ''){
            this.DataSeasonal = this.formatDateNoOreJQuery(this.DataSeasonal);
            this.ChkSeasonalOrder = true;
        }
    },
    methods:{
        calcolaSpSped: function(){
            let indirizzo = this.$store.getters.getShippingAddress;
            CartService.CalcolaSpSpedizione(this.$store.getters.getToken, indirizzo, 'B2B').then(
                (data) => {
                    this.$store.commit("setSpSpedizione", data);
                    this.$store.commit('setCheckOutAbilitato',true);
                }
            );
        },
        getCart: function(){
            CartService.getCartByUsername(this.$store.getters.getToken).then(
                (data) => {
                    if(data){
                        let responseCart = {};
                        Object.assign(responseCart, data);
                        if(responseCart.Status == 1){
                            this.$store.commit('resetCarrelloTmp');
                            this.$store.commit('updateCarrello', responseCart.Carrello);
                            this.$store.commit('setChkSeasonalOrders',(responseCart.Carrello?.ChkSeasonalOrder ?? false));
                            this.$emit("UpdateCart")
                        }
                    }
                }
            );
        },
        SetSeasonalDate: function(chkDelete){
            if(chkDelete){
                this.DataSeasonal = null;
            }
            CartService.setSeasonalDate(this.$store.getters.getToken, this.$store.getters.getCarrello?.Testata?.IdCarrello, this.DataSeasonal).then(
                () => {
                    this.getCart();
                }
            );
        }
    }
}
</script>

<style>
.centerElement{
    display: flex;
    align-items: center;
}

.align-y {
    display: flex;
    flex-direction: column;
    justify-content: center;
}
</style>